import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6" }, "Shortly you will receive an email summary of the internet service you have just ordered. This will have a copy of your contract, and contain all the important information you will need.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6" }, "If you need a technician to visit prior to connection, someone will be in touch in the coming days to arrange your appointment.", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6" }, "Once your internet has been activated and you are up and streaming, we will send you your first invoice.", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "And, that's about it! Enjoy your new internet service!", -1)

import HeroText from '../components/content/HeroText.vue';
import Text from '../components/content/Text.vue';
import Title from '../components/content/Title.vue';
import Container from '../components/content/Container.vue';
import HelpOptions from '../components/content/HelpOptions.vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');
const contacts = brandService.getContacts();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Container, null, {
      default: _withCtx(() => [
        _createVNode(HeroText, {
          title: "Congratulations!",
          subtitle: "Your internet service is being provisioned."
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Container, null, {
        default: _withCtx(() => [
          _createVNode(Text, null, {
            default: _withCtx(() => [
              _createVNode(Title, {
                class: "mb-6",
                title: "What's next?",
                subtitle: ""
              }),
              _hoisted_2,
              _hoisted_3,
              _hoisted_4,
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(HelpOptions, {
            class: "pb-20",
            features: _unref(contacts)
          }, null, 8, ["features"])
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})